'use client';

import type { PortfolioTemplateKind, PortfolioRenderData } from '../../types';
import { ArchitectTemplate } from './ArchitectTemplate';
import { ClassicTemplate } from './ClassicTemplate';
import { MinimalTemplate } from './MinimalTemplate';
import { ModernTemplate } from './ModernTemplate';

export type PortfolioTemplateRendererProps = {
  template: PortfolioTemplateKind;
  data: PortfolioRenderData;
  isPublicView: boolean;
  theme?: 'light' | 'dark';
  primaryColor?: string;
  editHref?: string;
};

export function PortfolioTemplateRenderer({
  template,
  data,
  isPublicView,
  theme = 'light',
  primaryColor = '#39b6a7',
  editHref,
}: PortfolioTemplateRendererProps) {
  const props = {
    data,
    isPublicView,
    theme: theme as 'light' | 'dark',
    primaryColor,
    editHref,
  };

  switch (template) {
    case 'architect':
      return <ArchitectTemplate {...props} />;
    case 'classic':
      return <ClassicTemplate {...props} />;
    case 'minimal':
      return <MinimalTemplate {...props} />;
    case 'modern':
    default:
      return <ModernTemplate {...props} />;
  }
}
